import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { styles } from './Tab.styles';
import { TabProps } from './TabProps';
import Typography from 'src/components/Text/Text';

const Tab: React.FC<TabProps> = ({
  label,
  active,
  onTabPress,
  disabled,
  renderTab,
  icon,
  tabPosition = 'top',
  testID,
}) => {
  const renderIcon = (label: string) => {
    if (typeof icon === 'function') return icon(label);
    return icon;
  };

  return (
    <View style={[styles.container, tabPosition === 'bottom' && styles.bottomTabs]}>
      <TouchableOpacity
        testID={testID}
        onPress={() => !disabled && onTabPress()}
        disabled={disabled}
        style={[styles.tab, styles.activeTab, disabled && styles.disabledTab]}>
        {renderIcon && renderIcon(label)}
        {renderTab ? (
          renderTab(label, active)
        ) : (
          <Typography variant={active ? 'h4' : 'body2'}>{label}</Typography>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default Tab;
